import { Link, useOutletContext } from "react-router-dom";
import { Image, ExternalLink } from "lucide-react";

export default function AdminDashboard() {
  const { tenant, slug } = useOutletContext();
  const modules = tenant?.modules_enabled || [];

  return (
    <div className="p-8 max-w-4xl" data-testid="admin-dashboard">
      <h1 className="text-2xl font-bold text-white mb-1">Welcome back</h1>
      <p className="text-slate-500 text-sm mb-8">Manage your website content below.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
        <Link
          to={`/t/${slug}/admin/hero`}
          className="bg-[#1E293B] border border-white/[0.06] rounded-lg p-5 hover:border-orange-500/30 transition-colors group"
          data-testid="hero-module-card"
        >
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-lg bg-orange-500/10 flex items-center justify-center">
              <Image size={18} className="text-orange-500" />
            </div>
            <h3 className="text-white font-semibold">Hero Section</h3>
          </div>
          <p className="text-slate-500 text-sm">
            Edit your headline, background image, and call-to-action button.
          </p>
        </Link>

        <a
          href={`/t/${slug}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#1E293B] border border-white/[0.06] rounded-lg p-5 hover:border-white/10 transition-colors"
          data-testid="view-live-site-card"
        >
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-lg bg-emerald-500/10 flex items-center justify-center">
              <ExternalLink size={18} className="text-emerald-500" />
            </div>
            <h3 className="text-white font-semibold">View Live Site</h3>
          </div>
          <p className="text-slate-500 text-sm">
            Open your public website in a new tab.
          </p>
        </a>
      </div>

      {modules.length > 1 && (
        <div className="bg-[#1E293B] border border-white/[0.06] rounded-lg p-5">
          <h3 className="text-white font-semibold mb-2">Coming soon</h3>
          <p className="text-slate-500 text-sm">
            Modules like About, Contact, Hours, Menu, and more are in development.
            The Hero section is fully editable now.
          </p>
        </div>
      )}
    </div>
  );
}
